// Hook: GET /company/budget-usage - bulk podsumowanie wykorzystania budzetu
// dla struktury firmy zalogowanego klienta.

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type TBudgetPeriod = 'm' | 'q' | 'y';

export interface IBudgetUsageItem {
  id?: number;
  user_id?: number;
  amount: number | null;
  spent: number;
  remaining: number | null;
  period: TBudgetPeriod;
}

export interface IResponse {
  locations: IBudgetUsageItem[];
  departments: IBudgetUsageItem[];
  users: IBudgetUsageItem[];
}

const getCompanyBudgetUsage = (): Promise<IResponse> =>
  axios.get('/company/budget-usage');

export const useGetCompanyBudgetUsage = (
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>('company-budget-usage', getCompanyBudgetUsage, options);
